exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.divider_divider_2uUWW {\r\n    border-right: 1px dashed var(--ui-black-transparent);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"divider": "divider_divider_2uUWW"
};